import React from 'react'
import styles from './Nav.module.css'


function Nav({ onBack }) {
  return (
    <div>
        <div className={styles.nav}>
            <div className={styles.navLeft}>
                <a href='./' className={styles.firstName}>TREVOR</a>
                <a href='./' className={styles.lastName}>TRUSTY</a>
            </div>
            <div className={styles.navRight}>
                {onBack
                  ? <button className={styles.navBtnBack} onClick={onBack}>← BACK</button>
                  : <>
                      <a className={styles.navBtnGithub}>GITHUB</a>
                      <a className={styles.navBtnProjects}>PORTFOLIO</a>
                    </>
                }
            </div>
        </div>
    </div>
  )
}

export default Nav